<template>
  <div>
    <p><b-button :to="{ name: 'CreatePrintServer' }">Create</b-button></p>
    <b-table striped hover :fields="fields" :items="servers">
      <template slot="actions" slot-scope="cell">
        <b-button-group>
          <b-button
            size="sm"
            class="align-top"
            variant="outline-secondary"
            :to="{ name: 'EditPrintServer', params: { id: cell.item.id } }"
          >
            <icon name="edit" class="align-middle"></icon>
          </b-button>
          <click-confirm>
            <b-button
              size="sm"
              variant="outline-secondary"
              @click.stop="removeServer(cell.item)"
            >
              <icon name="remove" class="align-middle"></icon>
            </b-button>
          </click-confirm>
        </b-button-group>
      </template>
    </b-table>
  </div>
</template>

<script>
import Notify from "@/notify";
import PrintersApi from "@/printers_api";
import ClickConfirm from "click-confirm";

export default {
  components: {
    "click-confirm": ClickConfirm,
  },
  mixins: [Notify],
  data() {
    return {
      fields: ["host", "api_key", "server_type", "actions"],
      servers: [],
    };
  },
  async created() {
    this.refresh();
  },
  methods: {
    async refresh() {
      try {
        const response = await new PrintersApi(
          this.$auth.getAccessToken()
        ).retrieveServers();
        this.servers = response.data;
      } catch (e) {
        this.notifyError(e.message);
      }
    },
    async removeServer(item) {
      try {
        await new PrintersApi(this.$auth.getAccessToken()).deleteServer(
          item.id
        );
        await this.refresh();
      } catch (e) {
        this.notifyError(e.message);
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/printers/ServerTable.vue